export default __webpack_public_path__ + "assets/a80c9702f76227046043e14f7746910f.png";